export class Practice{
    PracticeId:number;
    Name:string;

}

export class RequestType{
    transactionStatusId:number;
    name:string;
    category:string;

}